<template>
  <div class="invite-tenant">
    <invite-user />
  </div>
</template>

<script>
import InviteUser from '../../components/manage/inviteUser.vue'
export default {
  components: { InviteUser }

}
</script>

<style lang="scss" scoped >

</style>
